import * as _ from 'underscore';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import { validators } from '../../../../_common/platform/ts/validators';
import * as appTheme from '../../../../_common/platform/ts/appTheme';

declare var require: any;

var template = require('!!raw-loader!pdc-widget-folder-ws/src/mainTheme.template.css').default;

import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

template;

declare var Color: any;
declare var pdc: any;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: 'widget-folder-ws',
            name: 'Workspace Selector',
            parent: 'widget',

            themeType: 'Workspace Selector',
            visibility: ['application', 'workspace', 'pdc-widget-folder-ws']
        }
    ]);

    appTheme.registerVars([
        {
            id: 'widget-folder-ws-tiles-background',
            param: new ColorBoxField(
                glob,
                'Workspace Selector Tiles Background',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.96).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'widget-folder-ws',
            deps: ['gray-base', 'surface-bg']
        },

        //LL: 22.07.21:
        {
            id: 'widget-folder-ws-tiles-width',
            param: new NumberField(
                glob,
                'Width of Tiles', //'Width of Tiles (keep empty for Automatic value)',
                [
                    validators.number.integer,
                    validators.number.positive,
                    validators.number.range(20, 400) // padding = 10
                ],
                100, //null,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-folder-ws'
        },
        {
            id: 'widget-folder-ws-tiles-height',
            param: new NumberField(
                glob,
                'Height of Tiles', //'Height of Tiles (keep empty for Automatic value)',
                [
                    validators.number.integer,
                    validators.number.positive,
                    validators.number.range(20, 400) // padding = 10
                ],
                100, //null,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-folder-ws'
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-folder-ws']);

    _init.push(glob);
}
